module.exports = __webpack_public_path__ + "img/type8.268a18e2.png";